import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { JobsService } from '../../../services/jobs.service';
import { MultistepProcessDetailsViewComponent } from '../../jobs-tab/multistep-process-details-view/multistep-process-details-view.component';

@Component({
    standalone: false,
    selector: 'app-check-process-button',
    templateUrl: './check-process-button.component.html',
    styleUrls: ['./check-process-button.component.scss']
})
export class CheckProcessButtonComponent implements OnInit {
    @Input()
    job: ITaskModel;

    constructor(private readonly dialog: MatDialog, private readonly jobsService: JobsService) {}

    ngOnInit(): void {}

    checkJobStatus(event) {
        this.jobsService.checkJobStatus(this.job);
        this.openCheckJobStatusDialog();

        event.stopPropagation();
    }

    openCheckJobStatusDialog() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.data = this.job;
        dialogConfig.minWidth = '600px';
        dialogConfig.maxHeight = '900px';
        this.dialog.open(MultistepProcessDetailsViewComponent, dialogConfig);
    }
}
